import React from 'react';
import cn from 'classnames';

import {useUI} from 'coreHooks';
import {getAssetUrl} from 'coreUtils/adapters/sdk';

import Image from 'brandComponents/Image';
import ShowOrHideOnBreakpoint from 'brandComponents/Responsive/ShowOrHideOnBreakpoint';

import MobileNavigationTriggers from '../MobileNavigationTriggers/MobileNavigationTriggers';

import {IServiceMenuProps} from './IServiceMenu';
import {
	MinicartServiceMenuItem,
	MyAccountServiceMenuItem,
	QuickSearchServiceMenuItem,
	WishlistServiceMenuItem,
} from './Subcomponents';

import styles from './ServiceMenu.module.scss';

const ServiceMenu = ({classNames}: IServiceMenuProps) => {
	const spinnerUI = useUI('spinner');
	const spinner = spinnerUI?.spinner;
	const spinnerSrc = getAssetUrl('static/img/service_menu/loader.gif');

	return (
		<div className={cn(classNames, styles['service-menu'])}>
			{spinner && (
				<div className={styles['service-menu__spinner-wrapper']}>
					<Image src={spinnerSrc} alt="" showSkeleton={false} />
				</div>
			)}

			<div
				className={cn(styles['service-menu__item'], styles['service-menu__item-quick-search'])}
				data-type="quick-search"
			>
				<QuickSearchServiceMenuItem />
			</div>

			<ShowOrHideOnBreakpoint query=">=medium" classNames={styles['service-menu__item-breakpoint']}>
				<div className={styles['service-menu__item']} data-type="wishlist">
					<WishlistServiceMenuItem />
				</div>
			</ShowOrHideOnBreakpoint>

			<div className={styles['service-menu__item']} data-type="account">
				<MyAccountServiceMenuItem />
			</div>

			<div className={cn(styles['service-menu__item'], styles['service-menu__cart'])} data-type="cart">
				<MinicartServiceMenuItem />
			</div>

			<MobileNavigationTriggers />
		</div>
	);
};

export default ServiceMenu;
